import React, { useEffect, useState } from "react";
import { Badge, Col, Form, Offcanvas, Row, Table } from "react-bootstrap";
import ManIconHighlighted from "../../../img/man-highlighted.png";
import ManIconInitiate from "../../../img/man-initiate.png";
import ManIconRed from "../../../img/manred.png";
import WomanIconHighlighted from "../../../img/woman-avatar-highlighted.png";
import WomanIconInitiate from "../../../img/woman-avatar.png";
import WomanIconRed from "../../../img/womanred.png";
import UnknownIconHighlighted from "../../../img/UnknownHighlight.png";
import UnknownIconInitiate from "../../../img/unknown.png";
import UnknownIconRed from "../../../img/unknownred.png";
import { useParams } from "react-router";
import Pagination from "../../Pagination";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsKitMetadataServices } from "../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";
import { studyTreatmentManagementServices } from "../../../APIServices/CTMS/studyTreatmentManagementServices";
import { FaLock } from "react-icons/fa";

const EnvelopeDetails = ({ Show, Hide, Title, subjectData, tableRef, onMouseDown }) => {
  const [subjectRow, setSubjectRow] = useState("");
  const [loader, setLoader] = useState(false);
  const [factors, setFactors] = useState([]);
  const [dispenseKit, setDispenseKit] = useState([]);
  const [columns, setColumns] = useState([]);
  const [treatmentColumns, setTreatmentColumns] = useState([]);
  const [dispenseKitCount, setDispenseKitCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const { studyId } = useParams();
  const getStudySingleSubjectRow = async () => {
    setLoader(true);
    const data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, subjectData?.siteId, subjectData?.subjectId);
    setSubjectRow(data?.data?.row);
    setFactors(data?.data?.factors || []);
    setLoader(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(dispenseKitCount / itemsPerPage);

  const getAssignedStudySubjectRandomizationKit = async () => {
    setLoading(true);
    const data = await eiwrsRandomizationSchemaServices.getAssignedStudySubjectRandomizationKit(
      studyId, subjectData?.siteId, subjectData?.subjectId, StudyMode, "", pageNumber, itemsPerPage
    );
    setDispenseKit(data?.data || []);
    setDispenseKitCount(data?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    Promise.all([
      eiwrsKitMetadataServices.getEIWRSKitMetadataData("active", studyId),
      studyTreatmentManagementServices.getStudyTreatmentColumnData("active", studyId),
    ]).then(([kitMetadata, treatmentData]) => {
      setColumns(kitMetadata?.data || []);
      setTreatmentColumns(treatmentData?.data || []);
    });
  }, []);

  useEffect(() => {
    if (subjectData) {
      getStudySingleSubjectRow();
      getAssignedStudySubjectRandomizationKit(pageNumber, itemsPerPage);
    }
  }, [subjectData, pageNumber, itemsPerPage]);

  const subjectFields = [
    ["SCREENID", "Screen Id"],
    ["RANDOMNUMBER", "Random No."],
    ["SUBJECTID", "Subject Id"],
    ["SCREENINGDATE", "Screening Date"],
    ["GENDER", "Subject Gender"],
    ["BOD", "Subject Date of Birth"],
    ["RANDOMIZATIONNUMBERMANUAL", "Randomization No (Manual)"],
    ["SCREENINGNUMBERMANUAL", "Screening No (Manual)"],
  ];

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 850 }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="text-center mb-2">
            <img
              src={
                subjectData?.screeningStatus === "fail" ||
                  subjectData?.criteriaFailed
                  ? (subjectData?.row?.GENDER)?.toLowerCase() === "male"
                    ? ManIconRed
                    : (subjectData?.row?.GENDER)?.toLowerCase() === "female"
                      ? WomanIconRed
                      : UnknownIconRed
                  : subjectData?.subjectStatus === "completed"
                    ? (subjectData?.row?.GENDER)?.toLowerCase() === "male"
                      ? ManIconHighlighted
                      : (subjectData?.row?.GENDER)?.toLowerCase() === "female"
                        ? WomanIconHighlighted
                        : UnknownIconHighlighted
                    : (subjectData?.row?.GENDER)?.toLowerCase() === "male"
                      ? ManIconInitiate
                      : (subjectData?.row?.GENDER)?.toLowerCase() === "female"
                        ? WomanIconInitiate
                        : UnknownIconInitiate
              }
              alt=""
              style={{ width: 70, height: 70 }}
            />
          </div>
          <div className="text-center">
            <Badge
              bg={
                subjectData?.screeningStatus === "fail" ||
                  subjectData?.criteriaFailed
                  ? "danger-subtle"
                  : subjectData?.subjectStatus === "completed"
                    ? "success-subtle"
                    : "primary-subtle"
              }
              className="br3 text-dark"
              style={{ fontSize: 10 }}
            >
              {subjectData?.subjectName}
            </Badge>
          </div>
          <hr />
          {loader ? (
            <PageLoader />
          ) : (
            <Row>
              {subjectFields.filter(([field]) => subjectRow?.[field]).map(([field, label]) => (
                <Col sm={6} md={4} lg={3} key={field} className="hstack gap-2">
                  <Form.Label className="fw-bold">{label} : </Form.Label>
                  <Form.Label className="text-capitalize">{subjectRow[field]}</Form.Label>
                </Col>
              ))}
              <Col sm={6} md={4} lg={3} className="hstack gap-2">
                <Form.Label className="fw-bold">Subject Status : </Form.Label>
                <Form.Label className="text-capitalize">
                  {subjectData?.subjectStatus || "NA"}
                </Form.Label>
              </Col>
              <Col sm={6} md={4} lg={3} className="hstack gap-2">
                <Form.Label className="fw-bold">Screening Status : </Form.Label>
                <Form.Label className="text-capitalize">
                  {subjectData?.screeningStatus || "NA"}
                </Form.Label>
              </Col>
              {factors?.map((item) => (
                <Col sm={6} md={4} lg={3} key={item?.name} className="hstack gap-2">
                  <Form.Label className="fw-bold">{item?.name} : </Form.Label>
                  <Form.Label className="text-capitalize">
                    {item?.value || "NA"}
                  </Form.Label>
                </Col>
              ))}
            </Row>
          )}
          {loading ?
            <PageLoader />
            : dispenseKitCount === 0 ? (
              <NoDataFoundTable MSG={`No study kits found.`} />
            ) :
              <>
                <Form.Label className="fw-bold">Kit Number : </Form.Label>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>
                        EventId
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>
                        Time Point Id
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>
                        Kit Number
                      </th>
                      {columns?.filter(column => column?.isUnique === "yes")?.map((item, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, 4 + index)}>
                          {item?.columnLabel}
                        </th>
                      ))}
                      {treatmentColumns?.map((item, index) => (
                        <th onMouseDown={(e) => onMouseDown(e, columns?.length + 4 + index)}>
                          {item?.columnLabel}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {dispenseKit?.map((kitData, index) => (
                      <tr  key={index}>
                        <td className="text-center">
                          {index + 1 + startIndex}.
                        </td>
                        <td>{kitData?.eventName}</td>
                        <td>{kitData?.timePointId || "_"}</td>
                        <td>{kitData?.kitNumber}</td>
                        {columns?.filter(column => column?.isUnique === "yes")?.map(item => {
                          const columnData = (kitData?.columns || [])?.find(
                            (ele) => ele?.columnName === item?.columnName
                          );
                          return (
                            <td
                              key={item?.columnId || item?.columnName}
                            >
                              {columnData?.columnValue || ""}
                            </td>
                          );
                        })}
                        {treatmentColumns?.map(item => {
                          return (
                            <td
                              key={item?.columnId || item?.columnName}
                            >
                              {(eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                                kitData?.treatmentData[item?.columnName] || ""
                                :
                                <Badge style={{ width: 50 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                              }
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={dispenseKitCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default EnvelopeDetails;
